var _rect, _path, _path2, _path3, _rect2, _mask, _path4, _path5, _mask2, _path6, _path7, _path8, _path9, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path10, _path11, _path12, _path13, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRpoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.56553,
    y: 5.80332,
    width: 14.4123,
    height: 5.72098,
    rx: 2.86049,
    fill: "white",
    stroke: "#1C344C",
    strokeWidth: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5394 6.20934C14.8863 8.86444 12.3958 10.5345 9.97672 9.93945C7.82261 8.33329 7.50253 7.33151 8.1556 4.67641C9.40271 2.83053 10.5556 1.30137 12.9747 1.89639C15.3938 2.49141 16.1924 3.55424 15.5394 6.20934Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54039 2.93875C9.70919 3.15586 9.7091 3.15592 9.70903 3.15598L9.70903 3.15598L9.71011 3.15515L9.71591 3.15074C9.72138 3.14662 9.73002 3.14017 9.7417 3.13165C9.76506 3.1146 9.80053 3.08929 9.84701 3.05778C9.94004 2.9947 10.0767 2.90709 10.2483 2.81122C10.5927 2.61875 11.0709 2.39682 11.6142 2.27049C12.1568 2.1443 12.7547 2.11563 13.3477 2.29751C13.9371 2.47827 14.543 2.87335 15.0964 3.63069C15.8618 4.67807 15.7129 5.78112 15.3478 6.65841C15.2042 7.0034 15.029 7.3076 14.8687 7.5501L14.8116 5.84545C14.8065 5.69366 14.6793 5.57473 14.5275 5.57982C14.3757 5.58491 14.2568 5.71209 14.2619 5.86388L14.3448 8.33749C14.3499 8.48929 14.4771 8.60821 14.6289 8.60312L17.1025 8.52017C17.2543 8.51508 17.3732 8.3879 17.3681 8.23611C17.363 8.08432 17.2359 7.96539 17.0841 7.97048L15.2041 8.03353C15.4071 7.74791 15.6572 7.3462 15.8555 6.86974C16.2615 5.89425 16.4621 4.56738 15.5405 3.3062C14.9238 2.46226 14.2224 1.99049 13.509 1.77169C12.7993 1.55402 12.0989 1.59309 11.4896 1.73479C10.8808 1.87636 10.3533 2.12248 9.97998 2.3311C9.79267 2.43577 9.64249 2.53195 9.53837 2.60254C9.48627 2.63786 9.44559 2.66685 9.41745 2.68739C9.40338 2.69766 9.39243 2.70583 9.38474 2.71162L9.37568 2.71851L9.37301 2.72056L9.37215 2.72123L9.37184 2.72147C9.37171 2.72156 9.3716 2.72165 9.54039 2.93875ZM14.0207 8.89189C13.8437 8.68136 13.8438 8.68128 13.8439 8.68122L13.8431 8.68184L13.8381 8.68595C13.8333 8.68986 13.8256 8.69605 13.8152 8.70426C13.7942 8.7207 13.7622 8.74523 13.7199 8.77578C13.6354 8.83696 13.5107 8.92196 13.3529 9.0146C13.036 9.20061 12.5927 9.41341 12.0796 9.52923C11.5679 9.64472 10.9925 9.6627 10.4019 9.46717C9.81305 9.27219 9.18834 8.85809 8.5869 8.07561C7.84518 7.11064 7.96253 6.03883 8.29435 5.16684C8.42263 4.82974 8.5809 4.52939 8.72708 4.28761L8.8606 5.99128C8.87247 6.1427 9.00483 6.25582 9.15625 6.24396C9.30766 6.23209 9.42079 6.09972 9.40892 5.94831L9.21554 3.48088C9.20368 3.32946 9.07131 3.21634 8.9199 3.2282L6.45246 3.42158C6.30105 3.43345 6.18792 3.56581 6.19979 3.71723C6.21166 3.86864 6.34402 3.98177 6.49544 3.9699L8.36927 3.82304C8.18326 4.10929 7.95716 4.50648 7.78031 4.97123C7.41401 5.93383 7.2451 7.23244 8.15083 8.41079C8.80989 9.26822 9.52191 9.75516 10.2291 9.9893C10.9346 10.2229 11.6145 10.198 12.2007 10.0657C12.7854 9.93374 13.2824 9.69375 13.6313 9.48891C13.8064 9.38613 13.9459 9.2912 14.0425 9.22129C14.0908 9.18631 14.1285 9.15751 14.1546 9.13701C14.1677 9.12676 14.1779 9.11857 14.1851 9.11272L14.1936 9.10572L14.1962 9.10359L14.197 9.10288L14.1973 9.10262C14.1975 9.10251 14.1976 9.10241 14.0207 8.89189Z",
    fill: "#1C344C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65563 13.1741H16.8874V25.115H6.65563V13.1741Z",
    fill: "white",
    stroke: "#1C344C",
    strokeWidth: 0.77
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3495,
    y: 12.7891,
    width: 3.08957,
    height: 2.74971,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_9296_772",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9417 15.0991H22.6625V25.0007H16.9417V15.0991Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9417 15.0991H22.6625V25.0007H16.9417V15.0991Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1125 15.0991V25.0007H23.2125V15.0991H22.1125Z",
    fill: "#1C344C",
    mask: "url(#path-6-inside-1_9296_772)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-2_9296_772",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.770142 15.0991H6.49104V25.0007H0.770142V15.0991Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.770142 15.0991H6.49104V25.0007H0.770142V15.0991Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32014 25.0007V15.0991H0.220142V25.0007H1.32014Z",
    fill: "#1C344C",
    mask: "url(#path-8-inside-2_9296_772)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 11.5789V15.0994",
    stroke: "#1C344C",
    strokeWidth: 0.383664
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6511 11.5789V15.0994",
    stroke: "#1C344C",
    strokeWidth: 0.383664
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.03088,
    y: 15.5393,
    width: 1.07325,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2061,
    y: 16.5615,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82556,
    y: 16,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2965,
    y: 16.5615,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4113,
    y: 15.5393,
    width: 1.07325,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.03088,
    y: 17.1892,
    width: 1.07325,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17.8257,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2061,
    y: 18.2112,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 21.4771,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2061,
    y: 21.292,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82556,
    y: 17.8257,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2965,
    y: 18.2112,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82556,
    y: 21.4771,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2965,
    y: 21.292,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4333,
    y: 17.1892,
    width: 1.07325,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1648,
    y: 17.1892,
    width: 1.07325,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 12.299,
    y: 17.1892,
    width: 1.07325,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 8.03088,
    y: 18.8394,
    width: 1.07325,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 19.6514,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2061,
    y: 19.8621,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 23.3027,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2061,
    y: 22.9419,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82556,
    y: 19.6514,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2965,
    y: 19.8621,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82556,
    y: 23.3027,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2965,
    y: 22.9419,
    width: 0.82558,
    height: 0.82558,
    fill: "#1C344C"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4113,
    y: 18.8394,
    width: 1.07325,
    height: 0.82558,
    fill: "#1C344C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4467 13.368C21.5717 13.0645 21.6322 12.7383 21.6243 12.4102C21.6165 12.0821 21.5404 11.7592 21.4009 11.462C21.2615 11.1649 21.0617 10.9 20.8143 10.6843C20.567 10.4686 20.2774 10.3067 19.9641 10.2089L19.7573 10.8718C19.9786 10.9409 20.1832 11.0552 20.3579 11.2076C20.5327 11.36 20.6738 11.5471 20.7723 11.757C20.8708 11.9669 20.9246 12.1951 20.9301 12.4269C20.9357 12.6587 20.893 12.8891 20.8046 13.1035L21.4467 13.368Z",
    fill: "#1C344C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12936 13.6971C2.00433 13.3936 1.94383 13.0674 1.95171 12.7393C1.95959 12.4112 2.03567 12.0883 2.17512 11.7911C2.31457 11.494 2.51434 11.2291 2.76171 11.0134C3.00908 10.7977 3.29864 10.6358 3.61198 10.538L3.8188 11.201C3.59746 11.27 3.39291 11.3844 3.21817 11.5368C3.04342 11.6892 2.90231 11.8763 2.8038 12.0862C2.70529 12.2961 2.65155 12.5242 2.64598 12.756C2.64042 12.9878 2.68315 13.2182 2.77147 13.4325L2.12936 13.6971Z",
    fill: "#1C344C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8006 12.4815C22.9082 12.2204 22.9602 11.9397 22.9534 11.6574C22.9467 11.375 22.8812 11.0972 22.7612 10.8415C22.6412 10.5858 22.4693 10.3579 22.2565 10.1723C22.0436 9.98668 21.7945 9.84738 21.5248 9.76327L21.3406 10.3538C21.5283 10.4123 21.7017 10.5093 21.8499 10.6385C21.9981 10.7677 22.1177 10.9264 22.2012 11.1043C22.2848 11.2823 22.3303 11.4757 22.335 11.6722C22.3398 11.8688 22.3035 12.0641 22.2286 12.2459L22.8006 12.4815Z",
    fill: "#1C344C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.775103 12.8114C0.66752 12.5502 0.615462 12.2696 0.622242 11.9872C0.629021 11.7049 0.69449 11.427 0.814482 11.1714C0.934475 10.9157 1.10637 10.6878 1.31922 10.5021C1.53207 10.3165 1.78123 10.1772 2.05085 10.0931L2.23505 10.6836C2.04737 10.7421 1.87393 10.8391 1.72576 10.9683C1.5776 11.0975 1.45794 11.2562 1.37442 11.4341C1.29089 11.6121 1.24532 11.8055 1.2406 12.0021C1.23588 12.1986 1.27212 12.394 1.347 12.5758L0.775103 12.8114Z",
    fill: "#1C344C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9296_772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7414 21.6091C12.6934 21.8772 12.5644 22.1241 12.3718 22.3167C12.1792 22.5092 11.9322 22.6382 11.6641 22.6861C11.6539 22.6878 11.6436 22.6886 11.6333 22.6887C11.5869 22.6887 11.5422 22.6712 11.508 22.6397C11.4738 22.6083 11.4527 22.5652 11.4489 22.5189C11.4451 22.4726 11.4587 22.4266 11.4872 22.3899C11.5157 22.3533 11.557 22.3287 11.6028 22.321C11.9862 22.2565 12.3115 21.9311 12.3765 21.5471C12.3847 21.4986 12.4118 21.4555 12.4519 21.4271C12.4919 21.3986 12.5416 21.3873 12.59 21.3955C12.6385 21.4037 12.6816 21.4309 12.7101 21.4709C12.7385 21.511 12.7498 21.5607 12.7416 21.6091H12.7414ZM13.4843 21.393C13.4843 21.933 13.2698 22.4509 12.888 22.8327C12.5061 23.2145 11.9882 23.4291 11.4482 23.4291C10.9082 23.4291 10.3903 23.2145 10.0085 22.8327C9.62663 22.4509 9.41211 21.933 9.41211 21.393C9.41211 20.747 9.66662 20.0864 10.1678 19.4297C10.1836 19.409 10.2037 19.3918 10.2267 19.3793C10.2497 19.3668 10.2751 19.3594 10.3012 19.3574C10.3273 19.3555 10.3534 19.3591 10.378 19.368C10.4026 19.3769 10.425 19.3909 10.4438 19.4092L11.0019 19.9508L11.5109 18.5531C11.5211 18.5252 11.5378 18.5002 11.5597 18.4801C11.5815 18.46 11.6079 18.4455 11.6366 18.4378C11.6652 18.4301 11.6953 18.4293 11.7243 18.4357C11.7533 18.442 11.7803 18.4552 11.8031 18.4742C12.3092 18.8941 13.4843 20.0174 13.4843 21.393ZM13.1141 21.393C13.1141 20.3266 12.286 19.405 11.7673 18.9327L11.252 20.3458C11.2414 20.3748 11.2238 20.4007 11.2006 20.4211C11.1775 20.4416 11.1496 20.4559 11.1194 20.4628C11.0893 20.4697 11.058 20.469 11.0282 20.4606C10.9985 20.4523 10.9713 20.4367 10.9491 20.4152L10.339 19.8233C9.96949 20.3566 9.78231 20.8839 9.78231 21.393C9.78231 21.8348 9.95782 22.2585 10.2702 22.5709C10.5827 22.8834 11.0064 23.0589 11.4482 23.0589C11.89 23.0589 12.3138 22.8834 12.6262 22.5709C12.9386 22.2585 13.1141 21.8348 13.1141 21.393Z",
    fill: "#1C344C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9296_772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.99767,
    height: 4.99767,
    fill: "white",
    transform: "translate(8.57922 18.4314)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpoIcon);
export default __webpack_public_path__ + "static/media/rpo_icon.189553691f369287d2419a3e16141516.svg";
export { ForwardRef as ReactComponent };